import { createAction, createApiAction } from '@saucelabs/sl-util-redux';

import { api } from '../shared';
import * as types from './types';

export const cleanup = createAction(types.CLEANUP);
export const setCloudType = createAction(types.SET_CLOUD_TYPE);

export const changePage = createAction(types.CHANGE_PAGE);
export const changePerPage = createAction(types.CHANGE_PER_PAGE);
export const resetPage = createAction(types.RESET_PAGE);

// RDC
export const getArchivedRdcJobs = createApiAction(
  types.ARCHIVED_RDC_JOBS_GET,
  (payload) => api.getArchivedJobs(payload),
  { meta: { skipErrorPage: true } },
);

// VDC
export const getArchivedVdcJobs = createApiAction(
  types.ARCHIVED_VDC_JOBS_GET,
  (payload) => api.getArchivedJobs(payload),
  { meta: { skipErrorPage: true } },
);
